import { render } from "./emp_gov_details.vue?vue&type=template&id=39f20636&scoped=true"
import script from "./emp_gov_details.vue?vue&type=script&lang=js"
export * from "./emp_gov_details.vue?vue&type=script&lang=js"

import "./emp_gov_details.vue?vue&type=style&index=0&id=39f20636&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f20636"]])

export default __exports__